import { Message } from '../models'
import { getTransformedDate } from '../helpers'
import type { ColumnsType } from 'antd/lib/table'
import {
  CustomHeaderText,
  MessageItemAction,
  CustomText,
  MessageColumnMovileView
} from 'src/components'

const messageListColumns: ColumnsType<Message> = [
  {
    title: () => <CustomHeaderText text='developers.Date' />,
    responsive: ['sm'],
    sorter: (a: Message, b: Message) => {
      const dateA = new Date(a.date)
      const dateB = new Date(b.date)
      return dateA.getTime() - dateB.getTime()
    },
    sortDirections: ['descend', 'ascend'],
    render: (_, record) => <CustomText label={getTransformedDate(record.date)} />
  },
  {
    title: () => <CustomHeaderText text={'Messages.From'} isCentered />,
    responsive: ['sm'],
    dataIndex: 'sender_name',
    sorter: (a, b) => {
      const a_fromText = a.system ? 'ClimateTrade' : a.is_anonymous_user ? a.anonymous_sender_email :  `${a.sender_name} ${a.sender_lastname}`
      const b_fromText = b.system ? 'ClimateTrade' : b.is_anonymous_user ? b.anonymous_sender_email :`${b.sender_name} ${b.sender_lastname}`
      return a_fromText?.length - b_fromText?.length
    },
    render: (_, m: Message) => {
      const fromText = m.system ? 'ClimateTrade' : m.is_anonymous_user ? m.anonymous_sender_email :  `${m.sender_name} ${m.sender_lastname}`
      return (
        <div className='centered'>
          <CustomText label={fromText} />
        </div>
      )
    },
  },
  {
    title: () => <CustomHeaderText text={'Messages.Subject'} isCentered />,
    responsive: ['sm'],
    dataIndex: 'subject',
    sorter: (a, b) => a.subject?.length - b.subject?.length,
    render: (_, m: Message) => (
      <div className='centered'>
        <CustomText label={m.subject} strong={!m.read} />
      </div>
    )
  },

  {
    title: () => <CustomHeaderText text={'general.Actions'} isCentered />,
    responsive: ['sm'],
    align: 'center',
    render: (_, record) => <MessageItemAction message={record} />
  },

  {
    title: () => <CustomHeaderText text={'Offers.Message'} />,
    responsive: ['xs'],
    sorter: (a: Message, b: Message) => {
      const dateA = new Date(a.date)
      const dateB = new Date(b.date)
      return dateA.getTime() - dateB.getTime()
    },
    render: (_, record) => <MessageColumnMovileView message={record} />
  },
]

export default messageListColumns
